export const MAX_FILE_SIZE = 25000000;
export const FILE_TERMS_AND_CONDITIONS = "You are attempting to upload file(s) \
  to a sanctioned information system. This system is subject to monitoring to \
  ensure proper functioning, to protect against improper or unauthorized \
  uploading of potential malicious files. The continued use of the system \
  certifies that all uploaded files/documents, has been scanned and free of \
  malware, executable files, and are without malicious content. Intentional \
  infection, unauthorized access, use, or modification of this system may be \
  subject to criminal prosecution under Title 18 U.S. Code Section 1030";
export const FILE_SUCCESS = "Your file was successfully uploaded, you should \
  receive an email once it has been processed.";
export const FILE_NOT_UPLOADED = "File was not uploaded.";
export const FILE_WRONG_FORMAT = "File must have an extension of .csv.";
export const FILE_TOO_LARGE = "Your file is too large. It must be at most 20 MB.";
export const FILE_NOT_ENCODABLE = "The file contains special characters that \
  we are unable to encode. Please review your file and remove any special \
  characters such as: (, ), ~, @, #, $, %, ^, &, *, ?, /, \\, … \
  Once these special characters are removed, save your file, and \
  try to upload it again.";
const filePathRoot = "/sites/default/files/ita/documentation";
export const PATH_TO_DOCUMENTATION = filePathRoot
  + "/osha_injury-tracking-application-csv-documentation-v1.pdf";
export const PATH_TO_CSV_TEMPLATE = filePathRoot
  + "/osha_injury-tracking-application-summary-data-csv-template.csv";
export const PATH_TO_CSV_EXAMPLE = filePathRoot
  + "/osha_injury-tracking-application-summary-data-csv-sample-data.csv";
export const PATH_TO_CASE_DATA_DOCUMENTATION = filePathRoot
  + "/osha_injury-tracking-application-csv-documentation-v1.pdf";
export const PATH_TO_CASE_DATA_CSV_TEMPLATE = filePathRoot
  + "/osha_injury-tracking-application-summary-data-csv-template.csv";
export const PATH_TO_CASE_DATA_CSV_EXAMPLE = filePathRoot
  + "/osha_injury-tracking-application-summary-data-csv-sample-data.csv";

export const ALTERNATIVE_CLEANED_FILE = "Alternatively, download a cleaned version \
  of your file where these special characters have been removed from";



/** WEBPACK FOOTER **
 ** ./src/constants/fileUploadConstants.js
 **/